import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router';
import { RouteNames } from '@/router/RouteConstants';
// import { piniaUserStore } from '@/store/user';
// import { Actions } from '@/store/enums/StoreEnums';
// import JwtService from '@/core/services/JwtService';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    component: () => import('@/components/page-layouts/Auth.vue'),
    children: [
      {
        path: '/oauth-callback/:provider',
        name: RouteNames.OAUTH_CALLBACK,
        component: () =>
          import('@/views/crafted/authentication/sso/OauthCallback.vue'),
      },
      {
        path: '/sign-in',
        name: RouteNames.SIGN_IN,
        component: () =>
          import('@/views/crafted/authentication/basic-flow/SignIn.vue'),
      },
      {
        path: '/sign-up',
        name: RouteNames.SIGN_UP,
        component: () =>
          import('@/views/crafted/authentication/basic-flow/SignUp.vue'),
      },
      {
        path: '/password-reset',
        name: RouteNames.PASSWORD_RESET,
        component: () =>
          import('@/views/crafted/authentication/basic-flow/PasswordReset.vue'),
      },
      {
        path: '/password',
        name: RouteNames.SET_PASSWORD,
        component: () =>
          import('@/views/crafted/authentication/basic-flow/SetPassword.vue'),
      },
    ],
  },
  {
    path: '/',
    component: () => import('@/layout/Layout.vue'),
    children: [

      {
        path: '/dashboard',
        name: RouteNames.DASHBOARD,
        component: () => import('@/views/Dashboard.vue'),
      },
      {
        path: '/invoices/:statusFilter?',
        name: RouteNames.INVOICES,
        component: () => import('@/views/Invoices.vue'),
      },
      {
        path: '/invoice_enhancement/:statusFilter?',
        name: RouteNames.ENHANCEMENT_INVOICES,
        component: () => import('@/views/Enhancements.vue'),
      },
      {
        path: '/invoice_enhancement/:uuid/details',
        name: RouteNames.INVOICE_DETAILS,
        component: () => import('@/views/crafted/invoice-details/InvoiceDetails.vue'),
        redirect: (to) => ({ name: RouteNames.GENERAL, params: to.params }),
        children: [
          {
            path: '/invoice_enhancement/:uuid/details/general',
            name: RouteNames.GENERAL,
            component: () => import('@/views/crafted/invoice-details/General.vue'),
          },
          {
            path: '/invoice_enhancement/:uuid/details/matters',
            name: RouteNames.MATTERS,
            component: () => import('@/views/crafted/invoice-details/matters/Matters.vue'),
            children: [
              {
                path: '/invoice_enhancement/:uuid/details/matters/:matterRef',
                name: RouteNames.MATTER,
                component: () => import('@/views/crafted/invoice-details/matters/Matter.vue'),
              },
              {
                path: '/invoice_enhancement/:uuid/details/matters/timekeepers',
                name: RouteNames.TIMEKEEPERS,
                component: () => import('@/views/crafted/invoice-details/matters/UnassignedTimekeepers.vue'),
              },
            ],
          },
          {
            path: '/invoice_enhancement/:uuid/details/line-items',
            name: RouteNames.LINE_ITEMS,
            component: () => import('@/views/crafted/invoice-details/LineItems.vue'),
            redirect: (to) => ({ name: RouteNames.FEE_ITEMS, params: to.params }),
            children: [
              {
                path: 'fees',
                name: RouteNames.FEE_ITEMS,
                component: () => import('@/components/widgets/tables/FeesLineItems.vue'),
              },
              {
                path: 'expenses',
                name: RouteNames.EXPENSE_ITEMS,
                component: () => import('@/components/widgets/tables/ExpenseLineItems.vue'),
              },
            ],
          },
        ],
      },
      {
        path: '/account',
        name: RouteNames.ACCOUNT,
        component: () => import('@/views/crafted/account/Account.vue'),
        children: [
          {
            path: 'overview',
            name: RouteNames.ACCOUNT_OVERVIEW,
            component: () => import('@/views/crafted/account/Overview.vue'),
          },
          {
            path: 'settings',
            name: RouteNames.ACCOUNT_SETTINGS,
            component: () => import('@/views/crafted/account/Settings.vue'),
          },
          {
            path: 'billing',
            name: RouteNames.ACCOUNT_BILLING,
            component: () => import('@/views/crafted/account/Billing.vue'),
          },
        ],
      },
    ],
  },
  {
    // the 404 route, when none of the above matches
    path: '/404',
    name: RouteNames.ERROR_404,
    component: () => import('@/views/crafted/authentication/Error404.vue'),
  },
  {
    path: '/500',
    name: RouteNames.ERROR_500,
    component: () => import('@/views/crafted/authentication/Error500.vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/404',
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.beforeEach(() => {
  /* below code used the vue hooks for auth guards
      But the store.isUserAuthenticated always returns true.
      Commenting the code for now. Auth check and redirection is handled in
      Layout and Auth components for now.
      add params (to, from, next) t0 the above function*/

  // var authRoutes = (routes[0] ? routes[0].children?.map(a => a.name) : []);
  // var nonAuthRoutes = routes[1].children?.map(a => a.name);
  // authRoutes?.push('/' as RouteRecordName);
  // nonAuthRoutes?.push('/' as RouteRecordName);

  // const store = piniaUserStore();
  // console.log(store.isUserAuthenticated);

  // if (store.isUserAuthenticated && (nonAuthRoutes?.includes(to.name as string) || to.name === undefined)) {
  //   next({
  //     path: 'invoices',
  //     replace: true,
  //   });
  // } else if (!store.isUserAuthenticated && (authRoutes?.includes(to.name as string) || to.name === undefined)) {
  //   next({
  //     path: 'sign-in',
  //     replace: true,
  //   });
  // } else {
  //   next();
  // }

  setTimeout(() => {
    window.scrollTo(0, 0);
  }, 100);
});

export default router;
